
export default {
  head() {
    return {
      title: "Création site internet Paris | À partir 69€HT/mois",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez créer un site web pour votre entreprise à Paris ? Contactez l’agence de communication ALEO pour découvrir ses solutions digitales à des prix accessibles",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site internet Paris | À partir 69€HT/mois",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez créer un site web pour votre entreprise à Paris ? Contactez l’agence ALEO pour découvrir ses solutions digitales à des prix accessibles !",
        },
      ],
    };
  },
};
